import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AsyncSystemTask } from '@app/models/common/async-system-tasks.model';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { NotifyService } from '@app/services';
import { AsyncSystemTasksIndexTable } from '@async-system-tasks/services/async-system-tasks-index.table';

@Component({
    template: `<div class="ui basic segment">
        <app-header title="Background Jobs"> </app-header>
        <app-table [showSearch]="false" (menuItemSelected)="onMenuItemSelected($event)" [table]="table">
            <app-empty-state src="assets/illustrations/desktop.png" label="No background jobs have been run.">
            </app-empty-state>
        </app-table>
    </div>`,
})
export class AsyncSystemTasksIndexView {
    constructor(
        public table: AsyncSystemTasksIndexTable,
        private router: Router,
        private notify: NotifyService
    ) {}

    async onMenuItemSelected(event: MenuColumnEvent<AsyncSystemTask>): Promise<void> {
        const { menuItem, data: task } = event;

        if (menuItem === AsyncSystemTasksIndexTable.viewOption) {
            this.router.navigate([task.link]);
            return;
        }

        if (menuItem === AsyncSystemTasksIndexTable.deleteOption) {
            try {
                await task.delete();
                this.table.reload();
            } catch (e) {
                this.notify.error(e);
            }
        }
    }
}
